import React from 'react'
import Footer from '../Components/Footer/Footer';
import Itworks from '../Components/Itworks/Itworks';
import Navbar from '../Components/Navbar';



const Works = () => {
    return (
        <div>
            <Navbar/>
            <Itworks/>
            <Footer/>
        </div>
    )
}

export default Works
